// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from 'react';
import { classNames } from '@plasmicapp/react-web';

export type ArchiveCheckIconProps = React.ComponentProps<'svg'> & {
  title?: string;
};

export function ArchiveCheckIcon(props: ArchiveCheckIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      fill={'none'}
      viewBox={'0 0 24 24'}
      height={'1em'}
      width={'1em'}
      className={classNames('plasmic-default__svg', className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M10.076 5.5a6.44 6.44 0 01.423-1.5H6.25A3.25 3.25 0 003 7.25v11.5A3.25 3.25 0 006.25 22h11.5A3.25 3.25 0 0021 18.75v-7.56a6.49 6.49 0 01-1.499 1.077L19.5 14H15a.75.75 0 00-.75.75 2.25 2.25 0 01-4.5 0l-.007-.102A.75.75 0 009 14H4.5V7.25c0-.966.784-1.75 1.75-1.75h3.826zM22 6.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-6.655 1.65l-.959-1.28a.416.416 0 00-.665.499l1.247 1.662a.416.416 0 00.626.045l3.74-3.74a.416.416 0 10-.587-.588l-3.402 3.401z'
        }
        fill={'currentColor'}
      ></path>
    </svg>
  );
}

export default ArchiveCheckIcon;
/* prettier-ignore-end */
